"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _ImageContent = _interopRequireDefault(require("./ImageContent"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var _default = function _default(_ref) {
  var attachment = _ref.attachment;
  return _react.default.createElement(_ImageContent.default, {
    alt: attachment.name,
    src: attachment.contentUrl
  });
};

exports.default = _default;